/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
var all_product_tags = window.product_tags;

var match_tag = all_product_tags ? all_product_tags.find(value => /^QuantitySelect_/.test(value)) : undefined;

if(match_tag != undefined){
  var min_value = parseInt(match_tag.replace("QuantitySelect_", ""));
  var one_value = min_value;
  $("#qtyminus").click();
}
 if (min_value == undefined){
    min_value = 0;
   one_value = 1;
}

var input = document.getElementById("qtynum");
function qtyminus(){
  var num = +input.value;//+ for convert from string to number
  num--;
 
  if( num <= min_value ){
    input.value = one_value;
  }else {
    input.value = num;
  }
}
function qtyplus(){
  var num = +input.value;//+ for convert from string to number
  num++;
  input.value = num;
}
if(document.getElementById("qtyminus") != null){
document.getElementById("qtyminus").onclick = qtyminus;
document.getElementById("qtyplus").onclick = qtyplus;
}
this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){
    
    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id
      },
      complete: function(res){
      
        if(res.statusText  == "error"){
            console.log(res,data);
           el.removeClass('loading');
           el.text('Sold Out');
           el.addClass('soldout');
          return;
        }
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
       	  self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    
    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }
  
  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);

$(document).ready(function(){
	var nav = $(".nav-bar");
    var wd = $(window).width();
    if(wd < 1280 && wd > 1024){
      $(".navigation").html(nav); 
    }else{
      $(".header__logo").after(nav); 
    }
    $( window ).resize(function() {
      var wd = $(window).width();
      if(wd < 1280 && wd > 1024){
        $(".navigation").html(nav); 
      }else{
        $(".header__logo").after(nav); 
      }
    });
  
  if(wd < 769){
    var flkty = new Flickity( '.product-gallery__carousell', {
     // options
      cellAlign: 'left',
      contain: true
    });
  }
   
  var isHelpCenter = $(".help-center-wrapper").length;
  
  if(isHelpCenter > 0){
    $(".sublinks-dropdown__link").on("click", function(event){
    
        var checkcurrent = $(this).parents("ul").hasClass('current');
      if(checkcurrent){
            event.preventDefault();
        $(".sublinks li").removeClass("active");
        $(this).parent("li").addClass("active");
      	var indx = $(this).parent("li").index();
        var offsetTop = $($(".page-inner h2").get(indx)).offset().top;
        $('html, body').animate({
            scrollTop: offsetTop
        }, 500);
      }
    });
    
    $(".secondlevel").on("click", function(event){
      $(this).toggleClass("active");
      $(this).next(".sublinks").slideToggle("slow");
    });
  }
    
  var acc = document.getElementsByClassName("accordion");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }

$(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
    //console.log(scroll + " " + height);
    if(scroll > height){
     $(".sticky_cart").addClass("show");
    } else {
     $(".sticky_cart").removeClass("show");
    }
  });
  
  $("#btn-sticky-cart").click(function(){
  	$(".product-form__add-button").click();
  });
  
});



// selected variant access for desktop

/*const selectedVariant = document.querySelector(".product-form__variants");
const productGallery = document.querySelector(".product-gallery");


if (productGallery) {
  const productImg = productGallery.querySelectorAll("img");
  const aspectRatio = productGallery.querySelectorAll('.aspect-ratio');

  if (selectedVariant) {
    const variantInputs = selectedVariant.querySelectorAll("input");

    const updateAltText = () => {
      let allCheckedValues = Array.from(variantInputs)
        .filter((input) => input.checked) 
        .map((input) => input.value)
        .join(" "); 

      
     productImg.forEach((img) => {
        if (img.alt === allCheckedValues || img.alt === "notebook") {
          img.style.display = "block";
          img.parentElement.style.display = "block";
          const subParentMobile = img.parentElement;
          const parentMobile = subParentMobile.parentElement;
          parentMobile.parentElement.style.display = "block";
        } else {
          img.style.display = "none";
          img.parentElement.style.display = "none"; 
          const subParentMobile = img.parentElement;
          const parentMobile = subParentMobile.parentElement;
          parentMobile.parentElement.style.display = "none";
        }
      });
    };

    variantInputs.forEach((input) => {
      input.addEventListener("change", updateAltText);
    });

    updateAltText();
  }
}*/

// Desktop carousel handler
const selectedVariant = document.querySelector(".product-form__variants");
const productGallery = document.querySelector(".product-gallery");
if (productGallery) {
  const productImg = productGallery.querySelectorAll("img");
  const aspectRatio = productGallery.querySelectorAll('.aspect-ratio');
  if (selectedVariant) {
    const variantInputs = selectedVariant.querySelectorAll("input");
    const updateAltText = () => {
      let allCheckedValues = Array.from(variantInputs)
        .filter((input) => input.checked) 
        .map((input) => input.value)
        .join(" "); 
      
      productImg.forEach((img) => {
        if (img.alt === allCheckedValues || img.alt === "notebook") {
          img.style.display = "block";
          img.parentElement.style.display = "block";
          const subParentMobile = img.parentElement;
          const parentMobile = subParentMobile.parentElement;
          parentMobile.parentElement.style.display = "block";
        } else {
          img.style.display = "none";
          img.parentElement.style.display = "none"; 
          const subParentMobile = img.parentElement;
          const parentMobile = subParentMobile.parentElement;
          parentMobile.parentElement.style.display = "none";
        }
      });
    };
    variantInputs.forEach((input) => {
      input.addEventListener("change", updateAltText);
    });
    updateAltText();
  }
}
if (window.innerWidth <= 768) {
// Mobile slider handler
const mobileGallery = document.querySelector(".product-gallery__carousel-wrapper");
if (mobileGallery && selectedVariant) {
  const mobileCarousel = mobileGallery.querySelector('.product-gallery__carousell');
  const variantInputs = selectedVariant.querySelectorAll("input");
  const carouselItems = mobileGallery.querySelectorAll('.product-gallery__carousel-item');
  
  const updateMobileAltText = () => {
    let allCheckedValues = Array.from(variantInputs)
      .filter((input) => input.checked)
      .map((input) => input.value)
      .join(" ");
    
    // Destroy existing Flickity instance
    const existingFlkty = Flickity.data(mobileCarousel);
    if (existingFlkty) {
      existingFlkty.destroy();
    }
    
    // Hide/Show relevant items
    carouselItems.forEach((item) => {
      const img = item.querySelector('img');
      if (img && (img.alt === allCheckedValues || img.alt === "notebook")) {
        item.style.display = "block";
        item.setAttribute('aria-hidden', 'false');
      } else {
        item.style.display = "none";
        item.setAttribute('aria-hidden', 'true');
      }
    });
    
    // Reinitialize Flickity with original options
    new Flickity(mobileCarousel, {
      // Add your original Flickity options here
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: true,
      draggable: true
    });
  };

  variantInputs.forEach((input) => {
    input.addEventListener("change", updateMobileAltText);
  });
}}